import { SporsmalType } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { SimpleKontaktinfosporsmal } from '../reducer/sporsmalsflyt-types';
import { SimpleKontaktinfofelt } from './simpleKontaktinfofelt';

export interface CurrentSimpleKontaktinfosporsmal {
    type: SporsmalType.SimpleKontaktinfo;
    sporsmal: SimpleKontaktinfosporsmal;
    fulltNavn: string;
    mobilnummer: string;
    fodselsnummer: string;
}

export type BesvartSimpleKontaktinfosporsmal = CurrentSimpleKontaktinfosporsmal;

export const isSimpleKontaktinfoSporsmal = (
    currentSporsmal: CurrentSporsmal,
): currentSporsmal is CurrentSimpleKontaktinfosporsmal => currentSporsmal.type === SporsmalType.SimpleKontaktinfo;

const updateKontaktinfofelt = (
    opprinneligKontaktinfosvar: CurrentSimpleKontaktinfosporsmal,
    felt: SimpleKontaktinfofelt,
    svarTekst: string,
): CurrentSimpleKontaktinfosporsmal => {
    switch (felt) {
        case SimpleKontaktinfofelt.FulltNavn:
            return { ...opprinneligKontaktinfosvar, fulltNavn: svarTekst };
        case SimpleKontaktinfofelt.Mobilnummer:
            return { ...opprinneligKontaktinfosvar, mobilnummer: svarTekst.trim() };
        case SimpleKontaktinfofelt.Personnummer:
            return { ...opprinneligKontaktinfosvar, fodselsnummer: svarTekst.trim() };
        default:
            return opprinneligKontaktinfosvar;
    }
};

export const updateCurrentSimpleKontaktinfo = (
    currentSporsmal: CurrentSporsmal,
    felt: SimpleKontaktinfofelt,
    svarTekst: string,
): CurrentSporsmal => {
    if (isSimpleKontaktinfoSporsmal(currentSporsmal)) {
        return updateKontaktinfofelt(currentSporsmal, felt, svarTekst);
    }
    return currentSporsmal;
};
